import React from "react";
import Modal from "../Modal.jsx";

export default class EvertrheadModal extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Modal title="Everthread" id="everthread" onClose={this.props.onClose}>
        <div className="iframe-container">
          <iframe
            src="https://youtube.com/embed/lnaU4lxJg2Y"
            frameBorder="0"
            allowFullScreen
          />
        </div>
        <p>
          For 18 months, I led core development of a product that helps e-commerce
          teams create compelling visual experiences.
        </p>

        <p>
          The video shows one example created with the product.
        </p>

        <ul className="list-inline item-details">
          <li>
            Client:
            <strong>
              &nbsp;Everthread
            </strong>
          </li>
          <li>
            Date:
            <strong> 02/2018 - 7/2019 </strong>
          </li>
        </ul>
      </Modal>
    );
  }
}
